import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { TranslatePipe } from '@ngx-translate/core';

import { LayoutStore } from '../../../store/layout.store';
import { RouterFacade } from '../../../store/router.facade';
import { IconComponent } from '../../base-components/icon/icon.component';

@Component({
  selector: 'app-mobile-bottom-toolbar',
  imports: [
    MatButtonModule,
    TranslatePipe,
    IconComponent,
  ],
  templateUrl: './mobile-bottom-toolbar.component.html',
  styleUrls: ['./mobile-bottom-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileBottomToolbarComponent {
  private routerFacade = inject(RouterFacade);
  public layoutStore = inject(LayoutStore);

  public navigateToHome(): void {
    this.routerFacade.navigate(['/app/dashboard']);
  }

  public onChatClick(): void {
    this.layoutStore.openFullPanelModal('vocal-assistant');
  }

  public onAppsMenuClick(): void {
    this.layoutStore.openAppsPanel();
  }
}
